import {
  AutomobileMaintenancePart,
  AutomobileMaintenanceParts,
} from '@/reports/types/vehicles';
import { Text, Box } from '@/theme/index';
import { useScreenSize } from '@/utils/index';
import { DesktopRepairQuoteParts } from './DesktopRepairQuoteParts/DesktopRepairQuoteParts';
import { MobileRepairQuotePart } from './MobileRepairQuotePart/MobileRepairQuotePart';

interface VehicleRepairQuotePartsProps {
  parts: AutomobileMaintenanceParts;
}

export const VehicleRepairQuoteParts = ({
  parts,
}: VehicleRepairQuotePartsProps) => {
  const { isMobile } = useScreenSize();

  return (
    <Box>
      <Text variant="h4">Vehicle Parts</Text>
      {isMobile ? (
        <>
          {parts.map((item: AutomobileMaintenancePart) => (
            <MobileRepairQuotePart part={item} />
          ))}
        </>
      ) : (
        <DesktopRepairQuoteParts parts={parts} />
      )}
    </Box>
  );
};
